'use client'

import type {ReactNode} from 'react'

/**
 * WeChat-style sex indicator. `sex` is the raw string stored on the
 * contact row (`"0"` unknown / `"1"` male / `"2"` female). Returns
 * `null` for any value other than male/female so callers can render
 * inline with `{...}` without a wrapper div.
 *
 * The pill matches WeChat's color cues:
 *   - male   → blue ♂
 *   - female → pink ♀
 */
export function SexIcon({sex}: { sex?: string | null }): ReactNode {
    if (!sex) return null
    const kind = sex === '1' ? 'male' : sex === '2' ? 'female' : null
    if (!kind) return null

    const colorClass = kind === 'male' ? 'bg-blue-100 text-blue-500' : 'bg-pink-100 text-pink-500'
    const glyph = kind === 'male' ? '♂' : '♀'
    return (
        <span
            className={`inline-flex items-center justify-center w-5 h-5 rounded-full text-xs leading-none ${colorClass}`}
            aria-label={kind === 'male' ? '男' : '女'}
            title={kind === 'male' ? '男' : '女'}
        >
            {glyph}
        </span>
    )
}
